import script from "./ExpertiseList.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpertiseList.vue?vue&type=script&setup=true&lang=js"

import "./ExpertiseList.vue?vue&type=style&index=0&id=18c4b276&lang=scss"

const __exports__ = script;

export default __exports__